import * as RoutingTypes from './RoutingTypes';
import I18n from 'I18n';
const addAnyUserOption = (options, anyAvailableUser = false) => {
  const anyUserOption = {
    text: anyAvailableUser ? I18n.text('routing-ui.routingRules.options.anyAvailableUser') : I18n.text('routing-ui.routingRules.options.anyUser'),
    value: RoutingTypes.INBOX_USERS
  };
  return [anyUserOption, ...options];
};
const addKeepAssigneeOption = (options, disabled = false) => {
  const keepCurrentAssignmentOption = {
    text: I18n.text('routing-ui.routingRules.options.keepCurrentAssignment'),
    value: RoutingTypes.KEEP_ASSIGNEE,
    disabled
  };
  return [keepCurrentAssignmentOption, ...options];
};
const addUnassignedOption = options => {
  const unassignedOption = {
    text: I18n.text('routing-ui.routingRules.options.unassigned'),
    value: RoutingTypes.UNASSIGNED
  };
  return [unassignedOption, ...options];
};
const addContactOwnerOption = options => {
  const contactOwnerOption = {
    text: I18n.text('routing-ui.routingRules.options.contactOwner'),
    value: RoutingTypes.OWNER
  };
  return [contactOwnerOption, ...options];
};
const addAiChatbotOption = options => {
  const aiChatbotOption = {
    text: I18n.text('routing-ui.routingRules.options.aiChatbot'),
    value: RoutingTypes.AI_CHATBOT
  };
  return [aiChatbotOption, ...options];
};
export const getRoutingTypeOptions = config => {
  const {
    anyAvailableUser,
    disableKeepAssignee = false,
    showAnyUser = false,
    showKeepAssignee = false,
    showUnassigned = true,
    showOwner = true,
    aiChatbotId
  } = config;
  let options = [{
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: RoutingTypes.USERS_AND_TEAMS
  }];
  if (showOwner) {
    options = addContactOwnerOption(options);
  }
  if (showUnassigned) {
    options = addUnassignedOption(options);
  }
  if (showKeepAssignee) {
    options = addKeepAssigneeOption(options, disableKeepAssignee);
  }
  if (showAnyUser) {
    options = addAnyUserOption(options, anyAvailableUser);
  }
  if (aiChatbotId) {
    options = addAiChatbotOption(options);
  }
  return options;
};
export const getFallbackRoutingTypeOptions = () => [{
  text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
  value: RoutingTypes.USERS_AND_TEAMS
}, {
  text: I18n.text('routing-ui.routingRules.options.unassigned'),
  value: RoutingTypes.UNASSIGNED
}];
export const getSendFromGroupOptions = () => {
  return [{
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: RoutingTypes.USERS_AND_TEAMS
  }, {
    text: I18n.text('routing-ui.routingRules.options.contactOwner'),
    value: RoutingTypes.OWNER
  }, {
    text: I18n.text('routing-ui.routingRules.options.inbox'),
    value: RoutingTypes.INBOX_USERS
  }];
};